var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraAiDocumentCredits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32__x5F_Ai"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_440_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_94_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_290_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    d: "m313.581 330.032-12.339-41.129h-16.452l-12.339 41.129zm172.742-82.258v148.065h-65.806-246.775v-148.065h246.774z",
    fill: "#ffbe40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_266_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    d: "m420.516 395.839v57.58h-65.806-263.226v-370.161-82.258h255v74.032h74.032v172.742h-246.774v148.065z",
    fill: "#f4f6fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    d: "m420.516 75.032h-74.032v-74.032z",
    fill: "#e3e8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_180_",
    d: "m354.71 453.419v57.581h-329.033v-427.742h65.807v370.161z",
    fill: "#e3e8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_133_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    d: "m301.242 288.903 12.339 41.129h-41.129l12.338-41.129z",
    fill: "#ffbe40"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3686_",
    d: "m280.677 58.581h-139.838c-4.543 0-8.226-3.683-8.226-8.226s3.683-8.226 8.226-8.226h139.839c4.543 0 8.226 3.683 8.226 8.226s-3.684 8.226-8.227 8.226z",
    fill: "#8abeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3685_",
    d: "m280.677 107.935h-139.838c-4.543 0-8.226-3.683-8.226-8.226s3.683-8.226 8.226-8.226h139.839c4.543 0 8.226 3.683 8.226 8.226-.001 4.544-3.684 8.226-8.227 8.226z",
    fill: "#8abeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3684_",
    d: "m371.161 157.29h-230.322c-4.543 0-8.226-3.683-8.226-8.226s3.683-8.226 8.226-8.226h230.323c4.543 0 8.226 3.683 8.226 8.226s-3.684 8.226-8.227 8.226z",
    fill: "#8abeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3683_",
    d: "m371.161 206.645h-230.322c-4.543 0-8.226-3.683-8.226-8.226s3.683-8.226 8.226-8.226h230.323c4.543 0 8.226 3.683 8.226 8.226s-3.684 8.226-8.227 8.226z",
    fill: "#8abeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_",
    fill: "#f4f6fa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3681_",
    d: "m321.689 328.702c-.054-.33-.123-.654-.215-.97-.006-.021-.008-.043-.014-.064l-.016-.053c-.005-.016-.01-.033-.015-.049l-12.308-40.866c-1.044-3.479-4.246-5.701-7.879-5.701h-16.452c-3.633 0-6.835 2.221-7.879 5.701l-12.308 40.947c-.005.016-.01-.008-.015.009l-.016.032c-.006.021-.008.033-.014.054-.092.315-.161.635-.215.965-.014.085-.14.166-.152.252-.046.353-.191.708-.191 1.074v24.677c0 4.543 3.957 8.226 8.5 8.226s8.5-3.683 8.5-8.226v-16.71h24v16.71c0 4.543 3.957 8.226 8.5 8.226s8.5-3.683 8.5-8.226v-24.677c0-.366-.129-.723-.175-1.076-.011-.086-.122-.17-.136-.255zm-30.779-31.702h4.211l7.403 25h-19.018z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3682_",
    d: "m379.387 346h-8.387v-49h8.387c4.543 0 8.226-3.457 8.226-8s-3.683-8-8.226-8h-32.903c-4.543 0-8.226 3.457-8.226 8s3.683 8 8.226 8h8.516v49h-8.516c-4.543 0-8.226 3.957-8.226 8.5s3.683 8.5 8.226 8.5h32.903c4.543 0 8.226-3.957 8.226-8.5s-3.683-8.5-8.226-8.5z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraAiDocumentCredits);
export default __webpack_public_path__ + "static/media/extra-ai-document-credits.128e2c9527fbc6a81a7ead8539ad1096.svg";
export { ForwardRef as ReactComponent };